import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import ModalCreateBrand from "./ModalCreateBrand";
import { api } from "../../utils/Api";
import DataContext from "../../utils/Context/DataContext";
import Header from "../../components/Header/Header";
import ModalCreateOutlet from "./ModalCreateOutlet";

export default function Home(props) {
  const context = useContext(DataContext);
  const [create_brand_modal, SetCreateBrandModal] = useState({
    is_open: false,
    data: {},
  });
  const [create_outlet_modal, SetCreateOutletModal] = useState({
    is_open: false,
    data: {},
  });

  const [user_data, SetUserData] = useState({});
  const [recent_data, SetRecentData] = useState([]);
  const [brand_data, SetBrandData] = useState([]);
  const [outlet_data, SetOutletData] = useState([]);
  const [view_data, SetViewData] = useState({
    data: [],
    type: "",
  });

  useEffect(() => {
    console.log("Home On mount :", props);
    get_init();
  }, []);

  async function get_init() {
    let response = await api("/init");
    console.log("app_init :", response);
    if (response.status_code == 200) {
      SetUserData(response.response.user_details);
      localStorage.setItem(
        "user_data",
        JSON.stringify(response.response.user_details)
      );
      if (response.response.accounts.hasOwnProperty("recent")) {
        SetRecentData(response.response.accounts.recent);
        let view_value = {
          data: response.response.accounts.recent,
          type: "recent",
        };
        SetViewData(view_value);
      } else {
        if (response.response.accounts.hasOwnProperty("brands")) {
          let view_value = {
            data: response.response.accounts.brands,
            type: "brands",
          };
          SetViewData(view_value);
        } else {
          let view_value = {
            data: [],
            type: "brands",
          };
          SetViewData(view_value);
        }
      }

      if (response.response.accounts.hasOwnProperty("brands")) {
        SetBrandData(response.response.accounts.brands);
      }
      if (response.response.accounts.hasOwnProperty("outlets")) {
        SetOutletData(response.response.accounts.outlets);
      }
    }
  }

  function on_type_change(value: any) {
    let view_value = {
      data: [],
      type: "brands",
    };
    if (value == "recent") {
      view_value.data = recent_data;
      view_value.type = "recent";
    } else if (value == "brands") {
      view_value.data = brand_data;
      view_value.type = "brands";
    } else {
      view_value.data = outlet_data;
      view_value.type = "outlets";
    }
    SetViewData(view_value);
  }

  async function view(from: any, data: any, index: any) {
    let set_value = {
      brand_id: "",
      outlet_id: "",
      user_data: user_data,
    };

    if (from == "recent") {
      if (data.hasOwnProperty("outlet_id")) {
        console.log("View Outlet");
        set_value.brand_id = data.brand_id;
        set_value.outlet_id = data.outlet_id;
        let view_data_value = {
          name: data.name,
          brand_name: data.brand_name,
          type: "outlet",
        };
        localStorage.setItem("view_data", JSON.stringify(view_data_value));
      } else {
        console.log("View Brand");
        set_value.brand_id = data.brand_id;
        set_value.outlet_id = null;
        let view_data_value = {
          name: data.name,
          brand_name: "",
          type: "brand",
        };
        localStorage.setItem("view_data", JSON.stringify(view_data_value));
      }
    } else if (from == "brands") {
      console.log("View Brand");
      set_value.brand_id = data.id;
      set_value.outlet_id = null;
      let view_data_value = {
        name: data.name,
        brand_name: "",
        type: "brand",
      };
      localStorage.setItem("view_data", JSON.stringify(view_data_value));
    } else {
      console.log("View Outlet");
      set_value.brand_id = data.brand_id;
      set_value.outlet_id = data.id;
      let view_data_value = {
        name: data.name,
        brand_name: data.brand_name,
        type: "outlet",
      };
      localStorage.setItem("view_data", JSON.stringify(view_data_value));
    }

    let pass_data = {
      get: {
        brand: set_value.brand_id,
        outlet: set_value.outlet_id,
      },
    };
    // context.SetAppData(set_value);

    let response_data = await api("/account/visited", pass_data);
    console.log("api data :", response_data);
  }

  return (
    <div className="">
      {/* <div className="d-sm-block d-md-none">
       <Header />
       </div> */}
      <div className="header-bg"></div>
      <div className="home">
        <div className="row">
          <div className="col-md-3 sm-none col-0">
            <img src={require("../../assets/img/3.svg")} className="un_img1" />
          </div>
          <div className="col-md-6 col-12">
            <div className="sticky border-bottom">
              <div className="d-flex mb-4 align-items-center px-2">
                <h3 className="mb-0">Post productions</h3>

                <Link to={"create_brand"} className="mt-2 ms-auto me-2">
                  <button className="btn-outline p-2 fs-6 btn fw-bolder">
                    Create New
                  </button>
                </Link>
              </div>
              <div className="p-2 d-flex">
                <p
                  className={
                    view_data.type == "recent"
                      ? "me-5 cursor active_head"
                      : "me-5 cursor head"
                  }
                  onClick={() => {
                    on_type_change("recent");
                  }}
                >
                  Recent
                </p>
                <p
                  className={
                    view_data.type == "brands"
                      ? "me-5 cursor active_head"
                      : "me-5 cursor head"
                  }
                  onClick={() => {
                    on_type_change("brands");
                  }}
                >
                  Brands
                </p>
                <p
                  className={
                    view_data.type == "outlets"
                      ? "me-5 cursor active_head"
                      : "me-5 cursor head"
                  }
                  onClick={() => {
                    on_type_change("outlets");
                  }}
                >
                  Outlets
                </p>
              </div>
            </div>
            <div className="row p-2 m_t">
              {view_data.data.length > 0 ? (
                view_data.data.map((v_data, v_index) =>
                  view_data.type == "recent" ? (
                    v_data.hasOwnProperty("outlet_id") ? (
                      <div
                        className="col-lg-4 col-md-6 col-sm-6 col-12 mb-3"
                        onClick={() => {
                          view("recent", v_data, v_index);
                        }}
                        key={v_index}
                      >
                        <Link
                          to={
                            "outlet/" + v_data.brand_id + "/" + v_data.outlet_id
                          }
                          className="home_link"
                        >
                          <div className="card p-2 pt-3">
                            <div className="row t_h">
                              <div className="col-10">
                                <h6>{v_data.name}</h6>
                              </div>
                              <p className="col-2 p-0 v-small text-dark">
                                #{v_data.outlet_id}
                              </p>
                            </div>
                            <p className="n_h mb-0">{v_data.brand_name}</p>
                            <div className="d-flex a_h">
                              <i
                                className="fas fa-map-marker-alt pe-2 pt-1"
                                style={{ color: "gray" }}
                              ></i>
                              <p className="mb-1">
                                <small>{v_data.address}</small>
                              </p>
                            </div>
                            <div className="d-flex">
                              <i
                                className="fas fa-feather-alt pe-2 pt-1"
                                style={{ color: "gray" }}
                              ></i>
                              <p className="mb-2">
                                <small>Outlet</small>
                              </p>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ) : (
                      <div
                        className="col-lg-4 col-md-6 col-sm-6 col-12 mb-3"
                        onClick={() => {
                          view("recent", v_data, v_index);
                        }}
                        key={v_index}
                      >
                        <Link
                          to={"brand/" + v_data.brand_id}
                          className="home_link"
                        >
                          <div className="card p-2 pt-3">
                            <div className="row t_h">
                              <div className="col-10">
                                <h6>{v_data.name}</h6>
                              </div>
                              <p className="col-2 p-0 v-small text-dark">
                                #{v_data.brand_id}
                              </p>
                            </div>
                            <p className="n_h mb-0"></p>
                            <div className="d-flex a_h"></div>
                            <div className="d-flex">
                              <i
                                className="fas fa-feather-alt pe-2 pt-1"
                                style={{ color: "gray" }}
                              ></i>
                              <p className="mb-2">
                                <small>Brand</small>
                              </p>
                            </div>
                          </div>
                        </Link>
                      </div>
                    )
                  ) : view_data.type == "brands" ? (
                    <div
                      className="col-lg-4 col-md-6 col-sm-6 col-12 mb-3"
                      onClick={() => {
                        view("brands", v_data, v_index);
                      }}
                      key={v_index}
                    >
                      <Link to={"brand/" + v_data.id} className="home_link">
                        <div className="card p-2 pt-3">
                          <div className="row t_h">
                            <div className="col-10">
                              <h6>{v_data.name}</h6>
                            </div>
                            <p className="col-2 p-0 v-small text-dark">
                              #{v_data.id}
                            </p>
                          </div>
                          <p className="n_h mb-0"></p>
                          <div className="d-flex a_h"></div>
                          <div className="d-flex">
                            <i
                              className="fas fa-feather-alt pe-2 pt-1"
                              style={{ color: "gray" }}
                            ></i>
                            <p className="mb-2">
                              <small>Brand</small>
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ) : (
                    <div
                      className="col-lg-4 col-md-6 col-sm-6 col-12 mb-3"
                      onClick={() => {
                        view("outlets/", v_data, v_index);
                      }}
                      key={v_index}
                    >
                      <Link
                        to={"outlet/" + v_data.brand_id + "/" + v_data.id}
                        className="home_link"
                      >
                        <div className="card p-2 pt-3">
                          <div className="row t_h">
                            <div className="col-10">
                              <h6>{v_data.name}</h6>
                            </div>
                            <p className="col-2 p-0 v-small text-dark">
                              #{v_data.id}
                            </p>
                          </div>
                          <p className="n_h mb-0">{v_data.brand_name}</p>
                          <div className="d-flex a_h">
                            <i
                              className="fas fa-map-marker-alt pe-2 pt-1"
                              style={{ color: "gray" }}
                            ></i>
                            <p className="mb-1">
                              <small>{v_data.address}</small>
                            </p>
                          </div>
                          <div className="d-flex">
                            <i
                              className="fas fa-feather-alt pe-2 pt-1"
                              style={{ color: "gray" }}
                            ></i>
                            <p className="mb-2">
                              <small>Outlet</small>
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  )
                )
              ) : view_data.type == "recent" ? (
                <div>
                  <p>No Recent Data</p>
                </div>
              ) : view_data.type == "brands" ? (
                <div>
                  <p>No Brands Data</p>
                </div>
              ) : (
                <div>
                  <p>No Outlets Data</p>
                </div>
              )}
            </div>

            {/* <div className="row">
              <div className="w-25 mt-3">
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => {
                    SetCreateOutletModal((oldValues) => ({
                      ...oldValues,
                      is_open: true,
                    }));
                  }}
                >
                  Add
                </button>
              </div>
            </div> */}
          </div>
          <div className="col-md-3 sm-none">
            <div className="un_bottom_img">
              <img src={require("../../assets/img/2.svg")} className="un_img" />
            </div>
          </div>
        </div>
      </div>
      {/* <ModalCreateOutlet
        open={create_outlet_modal.is_open}
        close={(data) => {
          console.log("Create Outlet Modal On Close :", data);
          SetCreateOutletModal((oldValues) => ({
            ...oldValues,
            is_open: false,
          }));
        }}
      /> */}

      <ModalCreateBrand
        open={create_brand_modal.is_open}
        close={(data) => {
          console.log("Create Brand Modal On Close :", data);
          SetCreateBrandModal((oldValues) => ({
            ...oldValues,
            is_open: false,
          }));
        }}
      />
    </div>
  );
}
